var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaneDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6668 18.9116V16.7008L16.3335 9.33325V4.66659C16.3335 4.04775 16.0877 3.45425 15.6501 3.01667C15.2125 2.57908 14.619 2.33325 14.0002 2.33325C13.3813 2.33325 12.7878 2.57908 12.3502 3.01667C11.9127 3.45425 11.6668 4.04775 11.6668 4.66659V9.45575L2.3335 16.8233V18.9104L11.6668 15.6321V20.9999L8.16683 23.3333V25.6666L14.0002 23.3333L19.8335 25.6666V23.3333L16.3335 20.9999V15.5341L25.6668 18.9116Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneDark);
export default __webpack_public_path__ + "static/media/plane-dark.45377cd7fc56957277b467720f4a44a6.svg";
export { ForwardRef as ReactComponent };